import { __assign, __makeTemplateObject } from "tslib";
import React, { forwardRef } from 'react';
import MuiFormGroup from '@material-ui/core/FormGroup';
import { useThemeProps } from '../../../foundation';
import styled from '../../../foundation/styled-components';
var _RcFormGroup = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcFormGroup' });
    return React.createElement(MuiFormGroup, __assign({ ref: ref }, props));
});
/** @release */
var RcFormGroup = styled(_RcFormGroup)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
RcFormGroup.displayName = 'RcFormGroup';
export { RcFormGroup };
var templateObject_1;
